import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { axiosApi } from "../../../constants/axios_api";
import appUrl from "../../../constants/appUrl";
import * as yup from "yup"; // Import yup for validation
import { Formik, Form, Field, ErrorMessage } from "formik"; // Import Formik

const CreateGift = ({ gift, onClose }) => {
    const [initialValues, setInitialValues] = useState({
        giftName: "",
        giftQuantity: "",
        giftColor: "",
        giftPrice: "",
        giftDescription: "",
    });

    useEffect(() => {
        if (gift) {
            setInitialValues({
                giftName: gift.giftName,
                giftQuantity: gift.quantity,
                giftColor: gift.color,
                giftPrice: gift.price,
                giftDescription: gift.description,
            });
        }
    }, [gift]);

    const validationSchema = yup.object().shape({
        giftName: yup.string().required("Gift Name is required").matches(/^[a-zA-Z\s]*$/, "Only letters are allowed in name fields"),
        giftQuantity: yup.number().required("Gift Quantity is required").positive("Quantity must be a positive number").integer("Quantity must be an integer"),
        giftColor: yup.string().required("Gift Color is required").matches(/^[a-zA-Z\s]*$/, "Only letters are allowed in name fields"),
        giftPrice: yup.number().required("Gift Price is required").positive("Price must be a positive number"),
        giftDescription: yup.string().required("Gift Description is required"),
    });

    const handleGiftSubmit = async (values, { setSubmitting }) => {
        const payload = {
            giftName: values.giftName,
            quantity: values.giftQuantity,
            color: values.giftColor,
            price: values.giftPrice,
            description: values.giftDescription,
        };

        try {
            if (gift) {
                await axiosApi.put(`${appUrl.baseUrl}api/prizeRouter/gift/${gift._id}`, payload);
                toast.success("Gift updated successfully");
            } else {
                await axiosApi.post(`${appUrl.baseUrl}api/prizeRouter/gift`, payload);
                toast.success("Gift created successfully");
            }
            onClose();
        } catch (error) {
            console.error("Error creating/updating gift:", error.response ? error.response.data : error.message);
            toast.error(error.response ? error.response.data.message : error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleGiftSubmit}
            enableReinitialize
        >
            {({ isSubmitting }) => (
                <Form className="custom-dialog">
                    <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <label>Gift Name</label>
                        <Field
                            as={InputText}
                            name="giftName"
                            style={{ width: "100%" }}
                            className={({ field, form }) => form.errors.giftName ? "p-invalid" : ""}
                        />
                        <ErrorMessage name="giftName" component="small" className="p-error" />
                    </div>

                    <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <label>Gift Quantity</label>
                        <Field
                            as={InputText}
                            name="giftQuantity"
                            style={{ width: "100%" }}
                            className={({ field, form }) => form.errors.giftQuantity ? "p-invalid" : ""}
                        />
                        <ErrorMessage name="giftQuantity" component="small" className="p-error" />
                    </div>

                    <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <label>Gift Color</label>
                        <Field
                            as={InputText}
                            name="giftColor"
                            style={{ width: "100%" }}
                            className={({ field, form }) => form.errors.giftColor ? "p-invalid" : ""}
                        />
                        <ErrorMessage name="giftColor" component="small" className="p-error" />
                    </div>

                    <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <label>Gift Price</label>
                        <Field
                            as={InputText}
                            name="giftPrice"
                            style={{ width: "100%" }}
                            className={({ field, form }) => form.errors.giftPrice ? "p-invalid" : ""}
                        />
                        <ErrorMessage name="giftPrice" component="small" className="p-error" />
                    </div>

                    <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <label>Gift Description</label>
                        <Field
                            as={InputText}
                            name="giftDescription"
                            style={{ width: "100%" }}
                            className={({ field, form }) => form.errors.giftDescription ? "p-invalid" : ""}
                        />
                        <ErrorMessage name="giftDescription" component="small" className="p-error" />
                    </div>

                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <Button label={gift ? "Update Gift" : "Create Gift"} icon="pi pi-gift" className="p-button-success mt-3 ml-2" type="submit" disabled={isSubmitting} />
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default CreateGift;
